import angular, {
  IController,
  IComponentOptions,
  ITimeoutService
} from 'angular';
import IExternalUserTaskReport from '@Shared.Angular/@types/core/contracts/queryModel/reports/maintenance/externalUserTaskReport';

class ExternalUserTaskUsageReportComponentController implements IController {
  static $inject = ['$timeout'];
  // bindings
  public data: IExternalUserTaskReport[];

  public externalUserTaskRows: IExternalUserTaskReport[] = [];
  public clipboard: string;

  constructor(private $timeout: ITimeoutService) {}

  $onInit() {
    if (!this.data) {
      return;
    }

    this.$timeout(() => {
      this.clipboard = document.getElementById(
        'external-user-task-usage-report'
      )?.outerHTML;
    }, 100);
  }
}

class ExternalUserTaskUsageReportComponent implements IComponentOptions {
  public bindings: Bindings;

  constructor() {
    this.bindings = {
      data: '<'
    };
  }
  transclude = false;
  controller = ExternalUserTaskUsageReportComponentController;
  template = `
    <span flow-clipboard-copy="$ctrl.clipboard"></span>

    <table id="external-user-task-usage-report">
      <thead>
        <tr>
          <th>Business</th>
          <th style="max-width: 120px; word-wrap: break-word;">Flow Models with External User Task</th>
          <th>Flows Started</th>
          <th>Recipient Emails</th>
          <th>Recipient Emails Violating Policy</th>
        </tr>
      </thead>
      <tbody>
        <tr ng-repeat="row in $ctrl.data">
          <td>{{row.businessName}}</td>
          <td>{{row.activeWorkflowsCount}}</td>
          <td>{{row.flowsStarted}}</td>
          <td style="max-width: 200px; word-wrap: break-word;">{{row.recipientEmails}}</td>
          <td style="max-width: 200px; word-wrap: break-word;">{{row.externalBusinessDomainEmails}}</td>
        </tr>
      </tbody>
    </table>
  `;
}

angular
  .module('flowingly.runner.maintenance')
  .component(
    'externalUserTaskUsageReport',
    new ExternalUserTaskUsageReportComponent()
  );
